/* eslint-disable */
/* eslint-disable prettier/prettier */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useReducer, useState } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useAuth, handleLogin } from "context/auth";
import { useNavigate } from "react-router-dom";
// import ReCAPTCHA from "react-google-recaptcha";
import OtpInput from "react-otp-input";
import { useLoading, handleLoading } from "context/LoadingContext";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import Dialog from "components/Dialog/Dialog";
import { NotificationManager } from "react-notifications";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function EmployeeLogin() {
  const [auth, dispatchAuth] = useAuth();
  const navigate = useNavigate();
  const [, loadingDispatch] = useLoading();
  // reCaptcha
  // const [reCaptcha, setReCaptcha] = useState(null);
  // const reCaptchaOnChange = (value) => {
  //   setReCaptcha(value);
  // };
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      otpNumber: "",
    },
  });
  const [userTypeInput] = useState("employee");
  const [otp, setOtp] = useState("");
  const handleOtpChange = (otpInput) => setOtp(otpInput);
  const [dialogState, dispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const toggleDialog = () => {
    dispatchDialog({ type: "TOGGLE" });
    setOtp("");

    if (auth.otpRequired) {
      dispatchAuth({ type: "INIT", payload: { otpRequired: false } });
      setOtp("");
    }
  };

  useEffect(() => {
    if (auth.otpRequired) {
      toggleDialog();
    }
  }, [auth.otpRequired]);

  useEffect(() => {
    reset({});
  }, [userTypeInput]);

  const onSubmit = async (data) => {
    // if (!reCaptcha) return;
    try {
      handleLoading(loadingDispatch, true);
      await handleLogin(
        dispatchAuth,
        { ...data, otpNumber: otp },
        userTypeInput
      );
      setOtp("");
    } catch (error) {
      ErrorHandelFunctionApp(error) 
    }
    handleLoading(loadingDispatch, false);
  };
  useEffect(() => {
    if (auth.isLoggedIn) navigate("/");
  }, [auth.isLoggedIn]);

  return (
    <>
      <form
        className="auth__container"
        id="login"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        // style={{background:"red"}}
      >
        <h2>
          <img
            src={`${process.env.PUBLIC_URL}/petra_logo_web.svg`}
            alt="المناطق الحرة"
            className="max-w-100"
          />
        </h2>
        <h3>خدمة اصدار مخطط موقع وترسيم</h3>
        <Form.Group className="mb-4 input input-md" controlId="userName">
          <Form.Label>اسم المستخدم</Form.Label>
          <Form.Control
            {...register("userName", {
              required: "الرجاء ادخال الحقل",
            })}
          />
          {errors.userName && (
            <Form.Text className="text-danger">
              {errors.userName.message}
            </Form.Text>
          )}
        </Form.Group>
        <Form.Group className="mb-4 input input-md" controlId="password">
          <Form.Label>كلمة السر</Form.Label>
          <Form.Control
            type="password"
            {...register("password", {
              required: "الرجاء ادخال الحقل",
            })}
          />
          {errors.password && (
            <Form.Text className="text-danger">
              {errors.password.message}
            </Form.Text>
          )}
        </Form.Group>
        {/* <ReCAPTCHA
          // sitekey={process.env.REACT_APP_reCAPTCHA_SITE_KEY}
          sitekey={process.env.REACT_APP_reCAPTCHA_SITE_KEY}
          onChange={reCaptchaOnChange}
        /> */}

        <button
          type="submit"
          className="btn--outline" /* disabled={!reCaptcha} */
        >
          تسجيل الدخول
        </button>
      </form>
      <Dialog
        state={dialogState}
        dispatch={dispatchDialog}
        footer={false}
        title="الرجاء ادخال رمز التحقق"
        closeButton
        centered
        className="z-1057"
        backdropClassName="z-1056"
      >
        <div
          style={{
            direction: "ltr",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <OtpInput
            value={otp}
            onChange={handleOtpChange}
            numInputs={4}
            separator={<span className="mx-1" />}
            isInputNum
            shouldAutoFocus
            className="mb-4"
          />
        </div>
        <button
          type="submit"
          className="btn btn--primary w-100 text-center"
          form="login"
        >
          تأكيد
        </button>
      </Dialog>
    </>
  );
}

export default EmployeeLogin;
